import { all, takeEvery, put } from 'redux-saga/effects'
import store from 'store'
import { store as reduxStore } from 'index'
import actions from './actions'

export function* CHANGE_SETTING({ payload: { setting, value ,featureLabel = ""} }) {
  yield store.set(`app.settings.${setting}`, value)
  yield put({
    type: 'settings/SET_STATE',
    payload: {
      [setting]: value,
      featureLabel
    },
  })
}

export function* SETUP() {
  // detect isMobileView, isTabletView setting on app load and window resize
  const isMobileView = (load = false) => {
    const currentState = global.window.innerWidth <= 768
    const prevState = store.get('app.settings.isMobileView')
    if (currentState !== prevState || load) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileView',
          value: currentState,
        },
      })
    }
  }
  const isTabletView = (load = false) => {
    const currentState = global.window.innerWidth < 1200
    const prevState = store.get('app.settings.isTabletView')
    if (currentState !== prevState || load) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isTabletView',
          value: currentState,
        },
      })
    }
  }

  const isMobileMiniView = (load = false) => {
    const currentState = global.window.innerWidth < 575
    const prevState = store.get('app.settings.isMobileMiniView')
    if (currentState !== prevState || load) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileMiniView',
          value: currentState,
        },
      })
    }
  }
  const isMobileXSView = (load = false) => {
    const currentState = global.window.innerWidth < 441
    const prevState = store.get('app.settings.isMobileXSView')
    if (currentState !== prevState || load) {
      reduxStore.dispatch({
        type: 'settings/CHANGE_SETTING',
        payload: {
          setting: 'isMobileXSView',
          value: currentState,
        },
      })
    }
  }

  yield isMobileView(true)
  yield isTabletView(true)
  yield isMobileMiniView(true)
  yield isMobileXSView(true)
  yield window.addEventListener('resize', () => {
    isMobileView()
    isTabletView()
    isMobileMiniView()
    isMobileXSView()
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CHANGE_SETTING, CHANGE_SETTING),
    SETUP(), // run once on app load to init listeners
  ])
}
